import { flow, types } from 'mobx-state-tree';
import { saveAs } from 'file-saver';
import axios from 'axios';
import Notification from '../../../utils/Notification';
import { resolveDownloadFilename } from '../../../utils/common';

export const MediaFilePreviewWithDownloadState = types.model('MediaFilePreviewWithDownloadState', {
  fileUrl: types.maybeNull(types.string),
  fileType: types.optional(types.string, ''),
  filename: types.optional(types.string, 'download'),
}).views((self) => ({
  shouldRenderVideo()  { return self.fileType.toLowerCase() === 'video';  },
  shouldRenderImage()  { return self.fileType.toLowerCase() === 'image';  },
  shouldRenderAudio()  { return self.fileType.toLowerCase() === 'audio';  },
  shouldRenderPDF()    { return self.fileType.toLowerCase() === 'pdf';    },
  shouldRenderHTML()   { return self.fileType.toLowerCase() === 'html';   },
})).actions((self) => ({
  setFileUrl(newUrl) {
    self.fileUrl = newUrl;
  },
  downloadFile: flow(function* () {
    if (!self.fileUrl) return;
    const filename = resolveDownloadFilename(self.filename, self.fileUrl);
    try {
      const response = yield axios.get(self.fileUrl, { responseType: 'blob' });
      saveAs(response.data, filename);
    } catch (e) {
      new Notification()
        .setType('error')
        .setMessage(`Failed to download ${filename}`)
        .send();
    }
  }),
}));
